import { BCHCode, VERSION_STRING_GENERATOR_POLYNOMIAL } from 'error_correction';

/**
 * predefined alignment patterns for each QR version
 */
export const QRAlignmentPattern = [
  [],
  [6, 18],
  [6, 22],
  [6, 26],
  [6, 30],
  [6, 34],
  [6, 22, 38],
  [6, 24, 42],
  [6, 26, 46],
  [6, 28, 50],
  [6, 30, 54],
  [6, 32, 58],
  [6, 34, 62],
  [6, 26, 46, 66],
  [6, 26, 48, 70],
  [6, 26, 50, 74],
  [6, 30, 54, 78],
  [6, 30, 56, 82],
  [6, 30, 58, 86],
  [6, 34, 62, 90],
  [6, 28, 50, 72, 94],
  [6, 26, 50, 74, 98],
  [6, 30, 54, 78, 102],
  [6, 28, 54, 80, 106],
  [6, 32, 58, 84, 110],
  [6, 30, 58, 86, 114],
  [6, 34, 62, 90, 118],
  [6, 26, 50, 74, 98, 122],
  [6, 30, 54, 78, 102, 126],
  [6, 26, 52, 78, 104, 130],
  [6, 30, 56, 82, 108, 134],
  [6, 34, 60, 86, 112, 138],
  [6, 30, 58, 86, 114, 142],
  [6, 34, 62, 90, 118, 146],
  [6, 30, 54, 78, 102, 126, 150],
  [6, 24, 50, 76, 102, 128, 154],
  [6, 28, 54, 80, 106, 132, 158],
  [6, 32, 58, 84, 110, 136, 162],
  [6, 26, 54, 82, 110, 138, 166],
  [6, 30, 58, 86, 114, 142, 170],
];

/**
 * The underlying data structure for QRVersion, ensure that the version is a number between 1 and 40
 */
export class QRVersion {
  /** @type {number} */
  #value;

  /**
   *  Create a QR Version
   *  @param {number} value - The value of the QR Version
   *  @throws {Error} - If the value is not between 1 and 40
   */
  constructor(value) {
    if (value < 1 || value > 40) {
      throw new Error('Value must be between 1 and 40');
    }

    this.#value = value;
  }

  /**
   * Get the value of the QR Version
   * @returns {number} - The value of the QR Version
   */
  get value() {
    return this.#value;
  }

  /** Get the size of the resultant QR Code
   * @returns {number} - The size of the QR Code
   */
  toSize() {
    return this.value * 4 + 17;
  }

  /**
   * Get the version bits of the QR Code
   * @returns {number|null} - The 18 version bits of the QR Code, or null if the version is less than or equal to 6
   */
  getVersionBits() {
    if (this.#value <= 6) {
      return null;
    }

    const version_bits = this.#value << 12;
    const ecc = BCHCode(version_bits, VERSION_STRING_GENERATOR_POLYNOMIAL);
    const placement_bits = version_bits | ecc; // 18 bit
    return placement_bits;
  }

  /** Get the allignment pattern base of the given QR Version
   * @returns {number[]} - The alignment pattern base
   */
  getAlignmentPatterns() {
    return QRAlignmentPattern[this.value - 1];
  }
}
